export default class MoveInDateRange {
  static instances = {};

  /** Specs moving in on or before 30 days from today. */
  static get ThirtyDays() {
    return this.getInstance('30-days');
  }

  /** Specs moving in on or before 90 days from today. */
  static get NinetyDays() {
    return this.getInstance('90-days');
  }

  /** Specs moving in on or before 6 months from today. */
  static get SixMonths() {
    return this.getInstance('6-months');
  }

  static fromKey(key) {
    const map = {
      '30-days': MoveInDateRange.ThirtyDays,
      '90-days': MoveInDateRange.NinetyDays,
      '6-months': MoveInDateRange.SixMonths,
    };
    return map[key] ?? null;
  }

  /** @private */
  static getInstance(key) {
    if (!this.instances[key]) {
      this.instances[key] = new MoveInDateRange(key);
    }
    return this.instances[key];
  }

  constructor(name) {
    this.name = name;
  }

  toString() {
    return this.name;
  }
}
